// @ts-strict-ignore
import { Dropdown, DropdownButton } from "@aviary";
import { VariantDropdownItemDescriptor } from "@shared/components/VariantDropdownItemDescriptor/VariantDropdownItemDescriptor";
import type { Variant } from "@shared/types/graphqlGenerated";

import { VariantSelect, type VariantSelectItems } from "./VariantSelect/VariantSelect";

import * as styles from "./EmersonVariantSelect.styles";
interface Props {
  loading?: boolean;
  onOpen?: () => void;
  onVariantSelect: (id: string) => void;
  selectedVariantId: string;
  variantCount: number;
  variants: Pick<Variant, "id" | "availabilityStatus" | "descriptor" | "msrp">[];
}

const EmersonVariantSelect = ({
  loading,
  onOpen,
  onVariantSelect,
  selectedVariantId,
  variantCount,
  variants,
}: Props) => {
  const variantSelectItems = (varis): VariantSelectItems[] =>
    varis.map(vari => ({
      ...vari,
      dropdownItemDescriptor: (
        <VariantDropdownItemDescriptor
          descriptor={vari.descriptor}
          availabilityStatus={vari.availabilityStatus}
          descriptorStyle={styles.descriptor}
        />
      ),
      selectedItemDescriptor: vari.descriptor,
    }));

  if (variantCount === 1) {
    const [variantSelectLabel] = variantSelectItems(variants);

    return (
      <Dropdown>
        <DropdownButton
          data-testid="product-size"
          data-e2e="dosage-name"
          size="medium"
          hasIcon={false}
          css={styles.button}
        >
          {variantSelectLabel.selectedItemDescriptor}
        </DropdownButton>
      </Dropdown>
    );
  }

  return (
    <VariantSelect
      currentVariantId={selectedVariantId}
      loading={loading}
      onOpen={onOpen}
      onVariantSelect={onVariantSelect}
      variants={variantSelectItems(variants)}
    />
  );
};

export { EmersonVariantSelect };
